"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { ethers } from "ethers"; // @TODO: Keep a per-NonceManager pool of sent but unmined transactions for
//        rebroadcasting, in case we overrun the transaction pool

export var NonceManager = /*#__PURE__*/function (_ethers$Signer) {
  _inherits(NonceManager, _ethers$Signer);

  var _super = _createSuper(NonceManager);

  function NonceManager(signer) {
    var _this;

    _classCallCheck(this, NonceManager);

    _this = _super.call(this);
    _this._deltaCount = 0;
    ethers.utils.defineReadOnly(_assertThisInitialized(_this), "signer", signer);
    ethers.utils.defineReadOnly(_assertThisInitialized(_this), "provider", signer.provider || null);
    return _this;
  }

  _createClass(NonceManager, [{
    key: "connect",
    value: function connect(provider) {
      return new NonceManager(this.signer.connect(provider));
    }
  }, {
    key: "getAddress",
    value: function getAddress() {
      return this.signer.getAddress();
    }
  }, {
    key: "getTransactionCount",
    value: function getTransactionCount(blockTag) {
      if (blockTag === "pending") {
        if (!this._initialPromise) {
          this._initialPromise = this.signer.getTransactionCount("pending");
        }

        var deltaCount = this._deltaCount;
        return this._initialPromise.then(function (initial) {
          return initial + deltaCount;
        });
      }

      return this.signer.getTransactionCount(blockTag);
    }
  }, {
    key: "setTransactionCount",
    value: function setTransactionCount(transactionCount) {
      this._initialPromise = Promise.resolve(transactionCount).then(function (nonce) {
        return ethers.BigNumber.from(nonce).toNumber();
      });
      this._deltaCount = 0;
    }
  }, {
    key: "incrementTransactionCount",
    value: function incrementTransactionCount(count) {
      this._deltaCount += count ? count : 1;
    }
  }, {
    key: "signMessage",
    value: function signMessage(message) {
      return this.signer.signMessage(message);
      ;
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(transaction) {
      return this.signer.signTransaction(transaction);
    }
  }, {
    key: "sendTransaction",
    value: function sendTransaction(transaction) {
      if (transaction.nonce == null) {
        transaction = ethers.utils.shallowCopy(transaction);
        transaction.nonce = this.getTransactionCount("pending");
        this.incrementTransactionCount();
      } else {
        this.setTransactionCount(transaction.nonce);
      }

      return this.signer.sendTransaction(transaction).then(function (tx) {
        return tx;
      });
    }
  }]);

  return NonceManager;
}(ethers.Signer);